import React from 'react';
import Notifications from '../admin/Notifications';

const SuperAdminNotifications = () => (
  <Notifications
    shellConfig={{
      title: 'Super Admin Notifications',
      totalLabel: 'platform notification',
      backPath: '/superadmin/dashboard',
      backLabel: 'Back to Super Admin Dashboard',
    }}
  />
);

export default SuperAdminNotifications;
